import request from '@/modules/base/util/request'
import config from '@/config'

const baseUrl = `${config.resourceHost}`

export const OnboardingService = {
  Industry: {
    getAll: () => {
      return new Promise((resolve, reject) => {
        const url = `${baseUrl}industry`
        return request(url, { isConcurrent: true })
          .then(response => {
            const { body } = response
            resolve(body)
          })
          .catch(error => reject(error))
      })
    },
  },
}
